import { render, staticRenderFns } from "./CausesConcerns.vue?vue&type=template&id=380549a2"
import script from "./CausesConcerns.vue?vue&type=script&lang=js"
export * from "./CausesConcerns.vue?vue&type=script&lang=js"
import style0 from "./CausesConcerns.vue?vue&type=style&index=0&id=380549a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports